import { AddNewButtonShell } from '@/components/RootScreenButtons/buildingBlocks/AddNewButtonShell';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';

export const GoToPositionsButton = () => {
  const t = useTranslation();
  const { push } = useAppPush();
  return (
    <AddNewButtonShell
      onClick={() => {
        push('/positions');
      }}
      hideAddIcon
    >
      {t('section.POSITIONS')}
    </AddNewButtonShell>
  );
};
